module.exports = __webpack_public_path__ + "img/event_type_ctf.4bf860a0.svg";